module.exports = __webpack_public_path__ + "img/zongshumei_pink.d5bd6932.png";